// <s-sticky-buy> reveals the mobile buy bar once the main buy box (<s-product-form>) has
// scrolled above the viewport, and hides it again when the buyer scrolls back up.
// It re-renders with the 'product-form' partial, so each instance observes afresh.
class StickyBuy extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const target = this.closest('s-product-form');
    if (!target) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.toggleAttribute('data-visible', scrolledPast);
      this.inert = !scrolledPast;
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('s-sticky-buy')) {
  customElements.define('s-sticky-buy', StickyBuy);
}
